module.exports = __webpack_public_path__ + "img/attack_ice_dragon.919aa970.png";